export default __webpack_public_path__ + "static/media/2.5730d7f1.svg";